import { blockpotConfigManagerAbi } from '@/abi/blockPotConfigManagerAbi'
import { ContractName } from '@/constants/contract-addresses'
import useReadContract from './useReadContract'

export default function useConfigManagerRead() {
    return useReadContract(ContractName.CONFIG_MANAGER, blockpotConfigManagerAbi).read
}